define.alias("shared/utils/time", "media/utils/time");